import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const carousels = document.querySelectorAll(
    '.partners-carreer-block .partners-carreer-block__carousel'
  );

  if (0 < carousels.length) {
    carousels.forEach((carousel) => {
      const args = {
        slidesPerView: 'auto',
        spaceBetween: 30,
        loop: true,
        speed: 2000,

        breakpoints: {
          768: {
            spaceBetween: 50,
          },
          1080: {
            spaceBetween: 80,
          },
        },

        a11y: {
          firstSlideMessage: _x(
            'This is the first slide',
            'carousel first slide label',
            'vtx'
          ),
          lastSlideMessage: _x(
            'This is the last slide',
            'carousel last slide label',
            'vtx'
          ),
          paginationBulletMessage: _x(
            'Go to slide {{index}}',
            'carousel navigation label',
            'vtx'
          ),
          prevSlideMessage: _x(
            'Previous slide',
            'carousel previous label',
            'vtx'
          ),
          nextSlideMessage: _x('Next slide', 'carousel next label', 'vtx'),
        },
      };

      if (!document.documentElement.classList.contains('no-animation')) {
        args.autoplay = {
          delay: 0,
          disableOnInteraction: false,
        };
      }

      const partnerSwiper = new Swiper(carousel, args);

      document.addEventListener('disable-animations', function () {
        partnerSwiper.autoplay.stop();
      });

      document.addEventListener('enable-animations', function () {
        partnerSwiper.autoplay.start();
      });
    });
  }
});
